import React from "react";
import * as Mui from "@mui/material";
import { designFontFamily } from "services/constants/designTokens";

// Canonical status -> color mapping for the employee-facing "view request"
// panels. Mirrors the color language StatusRow already uses for the same
// statuses (CustomComponents/StatusRow.js) so a request's chip and its
// status-timeline dot always agree.
const STATUS_COLORS = {
  approved: "#0BB783",
  completed: "#0BB783",
  pending: "#C19A6B",
  applied: "#3699FF",
  rejected: "#F64E60",
  cancelled: "#6B7280",
  canceled: "#6B7280",
};

// colorCode (when the backend sends one for this request) wins over the
// local map below — same priority the Leave list table already uses for its
// StatusBadge, so a request's color agrees between the list and this panel.
export const requestStatusColor = (status, colorCode) => {
  if (colorCode) return colorCode;
  const byStatus = STATUS_COLORS[String(status || "").toLowerCase()];
  return byStatus || "#6B7280";
};

export const RequestStatusChip = ({ status, colorCode, sx = {} }) => {
  const color = requestStatusColor(status, colorCode);
  return (
    <Mui.Chip
      size="small"
      label={status || "-"}
      sx={{
        height: 24,
        fontFamily: designFontFamily,
        fontSize: 12.5,
        fontWeight: 600,
        color,
        backgroundColor: `${color}1A`,
        border: `1px solid ${color}55`,
        "& .MuiChip-label": { px: 1.1 },
        ...sx,
      }}
    />
  );
};

export default RequestStatusChip;
